import React from "react";
import { useQueryClient } from "react-query";
import moment from "moment";
import { message, Empty } from "antd";
// Connection Table element
import ConnectionTableElement from "../../components/SFTPConnector/ConnectionTableElement";
import Breadcrumb from "../../components/Breadcrumb";
import LoadingComponent from "../../components/Common/LoadingComponent";

// sftp connection react query calls
import { useGetConnections, useDeleteConnection } from "../../hooks/sftp.hooks";

const ConnectionConfigView = (props) => {
  const queryClient = useQueryClient();

  let tableHeight = 300;
  if (window.innerWidth > 700) {
    tableHeight = window.innerHeight - 300;
  }

  // Get sftp connection react query call
  const { isLoading: isLoadingSFTPData, data: SFTPConnectionsData } =
    useGetConnections({
      select: (data) => {
        const updatedData = [...data];
        return updatedData.sort((a, b) => {
          return moment(b?.create_at).diff(a?.create_at);
        });
      },
    });

  // Delete sftp connection react query call
  const deleteOptions = {
    onSuccess: () => {
      message.success("Connection Deleted Successfully");
    },
    onError: (error) => {
      message.error("Internal Server Error");
      console.error(error);
    },
    onSettled: () => {
      queryClient.invalidateQueries("SFTPConnectionData");
    },
  };

  const { isLoading: isDeleteConnections, mutate: mutateDeleteConnections } =
    useDeleteConnection(deleteOptions);

  const handleDelete = (key) => {
    mutateDeleteConnections(key);
  };

  return (
    <div>
      <div className="container_aa">
        <h3>View Connection</h3>
        <Breadcrumb
          routes={[
            { path: "/", breadcrumbName: "Dashboard" },
            {
              path: "ConnectionConfigView",
              breadcrumbName: "View Connection",
            },
          ]}
        />
      </div>
      <div className="container_ab">
        <div className="container_style_1_b" style={{ width: "100%" }}>
          <ConnectionTableElement
            bordered
            className="sm-custom-column-header"
            scroll={{ x: 4750, y: tableHeight }}
            dataSource={SFTPConnectionsData}
            handleDelete={handleDelete}
            isDeleteConnections={isDeleteConnections}
            rowKey="_id"
            locale={{
              emptyText: isLoadingSFTPData ? (
                <div className="spinner-table">
                  <LoadingComponent />
                </div>
              ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              ),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ConnectionConfigView;
